<template>
    <div class="progress_bar">
        <aicc-scenario-progress-cell v-for="(item, idx) in items" :key="idx" :answerType="item.answerType" :questionTitle="item.questionTitle" :questionContents="item.questionContents"/>
    </div>
</template>
<script>
import AICCScenarioProgressCell from './AICCScenarioProgressCell.vue';
export default {
    name:'aicc-scenario-progress-bar',
    components:{
        aiccScenarioProgressCell:AICCScenarioProgressCell,
    },
    props:{
        items: {
            type:[Array, Object],
            validator: function(val) {
                return Array.isArray(val);
            },
            default: ()=>[]
        },
    },
    data() {
        return {
            
        }
    }
}
</script>
